import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=c3823a36&scoped=true&"
import script from "./VideoManage.vue?vue&type=script&lang=js&"
export * from "./VideoManage.vue?vue&type=script&lang=js&"
import style0 from "./VideoManage.vue?vue&type=style&index=0&id=c3823a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3823a36",
  null
  
)

export default component.exports